import React from 'react';

import Add from './Add';
import Listt from './List';

export default function Index() {
  return (
    <>
      <Listt />
      <Add />
    </>
  );
}
